const STORAGE_KEY = 'recentSearches';
const RECENT_SEARCHES_LIMIT = 20;

export interface RecentSearch {
  keyword: string;
  thumbnail?: string;
}

export const getRecentSearches = (): RecentSearch[] => {
  try {
    const recentSearches = window.localStorage.getItem(STORAGE_KEY);

    return recentSearches ? JSON.parse(recentSearches) : [];
  } catch {
    return [];
  }
};

export const clearRecentSearches = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
};

export const saveRecentSearches = (list: RecentSearch[]) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    return;
  }
};

const findIndex = (list: RecentSearch[], keyword: string) =>
  list.findIndex(item => keyword === item.keyword);

export const saveRecentSearch = ({ keyword, thumbnail }: RecentSearch) => {
  const list = getRecentSearches();
  const existingIndex = findIndex(list, keyword);

  if (existingIndex === 0) {
    return;
  }
  if (existingIndex > -1) {
    // Move existing item to the beginning of an array
    list.unshift(list.splice(existingIndex, 1)[0]);
  } else {
    list.unshift({ keyword, thumbnail });
  }
  if (list.length > RECENT_SEARCHES_LIMIT) {
    list.pop();
  }

  saveRecentSearches(list);
};
